import { alpha, styled } from '@mui/material/styles';
import { Card } from '@mui/material';

const LIGHT_GRAY = '#FEFEFE';

const StyledCardNoHeight = styled(Card)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'light' ? LIGHT_GRAY : '#1F1F1F',
  boxShadow: `
  -4px -4px 5px ${alpha(theme.palette.primary.darker, 0.05)},
  4px 4px 2px ${alpha(theme.palette.primary.darker, 0.025)}
`,
}));

export default StyledCardNoHeight;
